var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classes,attrs:{"append":"","to":{ params: _vm.params }}},[_vm._v("\n  "+_vm._s(_vm.omitHashtag ? '' : '#')+_vm._s(_vm.tag)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }